import { createFileRoute, Outlet } from '@tanstack/react-router'
import { useAdminCheck } from '@/hooks/useAdminCheck'

export const Route = createFileRoute('/admin')({
    component: AdminLayout,
})

function AdminLayout() {
    const { isAdmin, loading, error } = useAdminCheck()

    // Show loading state while checking auth
    if (loading) {
        return (
            <div className="flex h-screen items-center justify-center">
                <div className="text-center">
                    <div className="mb-4 h-12 w-12 animate-spin rounded-full border-t-2 border-b-2 border-gray-900"></div>
                    <p className="text-gray-600">Loading...</p>
                </div>
            </div>
        )
    }

    // Check if user is admin (from backend verification)
    if (!isAdmin || error) {
        return (
            <div className="flex h-screen items-center justify-center">
                <div className="max-w-md rounded-lg bg-white p-8 text-center shadow-lg">
                    <div className="mb-4 text-6xl">🔒</div>
                    <h1 className="mb-2 text-2xl font-bold text-gray-900">
                        Access Denied
                    </h1>
                    <p className="mb-6 text-gray-600">
                        You don't have permission to access this page.
                    </p>
                    <a
                        href="/"
                        className="inline-block rounded-lg bg-black px-6 py-2 text-white hover:bg-gray-800"
                    >
                        Return Home
                    </a>
                </div>
            </div>
        )
    }

    // User is admin, render admin pages
    return (
        <div className="min-h-dvh bg-gray-50">
            <Outlet />
        </div>
    )
}
